import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from 'sentry';
import english from '../../i18n/en.json';
import spanish from '../../i18n/es.json';
import portuguese from '../../i18n/pt.json';
import { MfaService } from '../../services/mfa.service';
import { RecoveryCodesService } from '../shared/recovery-codes/services/recovery-codes.service';
var ReadRecoveryCodesComponent = /** @class */ (function () {
    function ReadRecoveryCodesComponent(data, fuseTranslationLoaderService, matDialogRef, fuseProgressBarService, recoveryCodesService, mfaService) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.matDialogRef = matDialogRef;
        this.fuseProgressBarService = fuseProgressBarService;
        this.recoveryCodesService = recoveryCodesService;
        this.mfaService = mfaService;
        this.isLoading = false;
        this.recoveryCodes = null;
        this.temporaryToken = null;
        this.downloadRecoveryCodesUrl = null;
        this.isRecreatedRecoveryCodes = false;
        this.nextStepAfterNewTemporaryToken = 1;
        this.me = data.me;
        this.type = data.type;
        this.configureRecoveryCodesStep = data.step;
        this.recoveryCodes = data.recoveryCodes;
        if (this.recoveryCodes) {
            this.createDocumentWithRecoveryCodes();
        }
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    ReadRecoveryCodesComponent.prototype.getRecoveryCodes = function (accessToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.isLoading = true;
                        this.temporaryToken = accessToken;
                        this.fuseProgressBarService.show();
                        _a = this;
                        return [4 /*yield*/, this.mfaService.getRecoveryCodes({
                                accessToken: this.temporaryToken
                            })];
                    case 1:
                        _a.recoveryCodes = _b.sent();
                        this.createDocumentWithRecoveryCodes();
                        this.configureRecoveryCodesStep = 1;
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _b.sent();
                        this.ensureTemporaryTokenIsValid(err_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReadRecoveryCodesComponent.prototype.recreateRecoveryCodes = function (accessToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, err_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        if (accessToken) {
                            this.temporaryToken = accessToken;
                        }
                        if (!this.temporaryToken) {
                            this.nextStepAfterNewTemporaryToken = 2;
                            this.configureRecoveryCodesStep = 0;
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        _a = this;
                        return [4 /*yield*/, this.mfaService.regenerateRecoveryCodes({
                                accessToken: this.temporaryToken
                            })];
                    case 1:
                        _a.recoveryCodes = _b.sent();
                        this.createDocumentWithRecoveryCodes();
                        this.configureRecoveryCodesStep = 1;
                        this.isRecreatedRecoveryCodes = true;
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _b.sent();
                        this.ensureTemporaryTokenIsValid(err_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReadRecoveryCodesComponent.prototype.createDocumentWithRecoveryCodes = function () {
        this.downloadRecoveryCodesUrl = this.recoveryCodesService.generateFileToDownload({
            recoveryCodes: this.recoveryCodes,
            userEmail: this.me.email
        });
    };
    ReadRecoveryCodesComponent.prototype.ensureTemporaryTokenIsValid = function (err) {
        if (['OldToken', 'InvalidToken'].includes(getErrorCode(err))) {
            this.nextStepAfterNewTemporaryToken = this.configureRecoveryCodesStep;
            this.configureRecoveryCodesStep = 0;
            return;
        }
        sentry.captureException(err, {
            extra: {
                message: 'Error on recovery codes',
                err: JSON.stringify(err)
            }
        });
    };
    return ReadRecoveryCodesComponent;
}());
export { ReadRecoveryCodesComponent };
